import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import Helper from "../plugins/Helper/Helper"
import i18n from '@/plugins/vue-i18n';
export class ExportMarketReport {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportMarketReportByProject(items, summary) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('market.market'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.marchant_name'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_number_only'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.shop_name'),
        key: 4,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.document_number_only'),
        key: 5,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_in_area'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('deposit'),
        key: 7,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('invoice.total_pending_invoice'),
        key: 8,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('income.difference'),
        key: 9,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.not_due'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_one_to_thirty_days'),
        key: 11,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_thirty_one_to_sixty_days'),
        key: 12,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_sixty_one_to_ninety_days'),
        key: 13,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_ninety_one_to_one_hundred_twenty_days'),
        key: 14,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_one_hundred_twenty_one_to_one_hundred_fifty_days'),
        key: 15,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_one_hundred_fifty_one_to_one_hundred_eighty_days'),
        key: 16,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_more_than_one_hundred_eighty_days'),
        key: 17,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]

    for (let item of items) {
      let documentId;
      if (item.invoice) documentId = item.invoice.documentId
      if (item.receipt) documentId = item.receipt.documentId

      worksheet.addRow({
        1: (item.contract && item.contract.market) ? item.contract.market.name || "" : "",
        2: (item.contract && item.contract.customer) ? item.contract.customer.fullName || "" : "",
        3: (item.contract) ? item.contract.contractId || "" : "",
        4: (item.contract) ? item.contract.businessName || "" : "",
        5: documentId || "",
        6: item.contract.areas.map(area => area.name).join(', ') || "",
        7: item.totalDeposit || 0,
        8: item.totaltotalUnpaid || 0,
        9: ((item.totalDeposit || 0) - (item.totaltotalUnpaid || 0)),
        10: item.totalNotDue || 0,
        11: item.total30Day || 0,
        12: item.total60Day || 0,
        13: item.total90Day || 0,
        14: item.total120Day || 0,
        15: item.total150Day || 0,
        16: item.total180Day || 0,
        17: item.totalGreaterThan180Day || 0
      })
    }
    worksheet.addRow({
      1: i18n.t('sum'),
      7: summary.totalDeposit || 0,
      8: summary.totaltotalUnpaid || 0,
      9: summary.totalDiff || 0,
      10: summary.totalNotDue || 0,
      11: summary.total30Day || 0,
      12: summary.total60Day || 0,
      13: summary.total90Day || 0,
      14: summary.total120Day || 0, 
      15: summary.total150Day || 0,
      16: summary.total180Day || 0,
      17: summary.totalGreaterThan180Day || 0
    })

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(items.length + 2).font = { bold: true };
    worksheet.mergeCells(`A${items.length + 2}:F${items.length + 2}`)
    worksheet.getCell(`A${items.length + 2}`).alignment = {
      vertical: 'center',
      horizontal: 'center'
    }

    for (let i = 2; i <= items.length + 2; i++) {
      const cellH = worksheet.getCell(`I${i}`);
      const value = cellH.value;

      if (value >= 0) {
        cellH.font = { ...cellH.font, color: { argb: '0029c66f' } }; // สีเขียว
      } else {
        cellH.font = { ...cellH.font, color: { argb: '00eb5455' } }; // สีแดง
      }
    }
    return this.saveFile(workbook, `project-invoice-report-${moment(new Date()).format("DDMMYYYY")}`);
  }

  static async exportMarketReportByMarket(items, summary) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('market.marchant_name'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_number_only'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.shop_name'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('customer.document_number_only'),
        key: 4,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_in_area'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('deposit'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('invoice.total_pending_invoice'),
        key: 7,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('income.difference'),
        key: 8,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.not_due'),
        key: 9,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_one_to_thirty_days'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_thirty_one_to_sixty_days'),
        key: 11,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_sixty_one_to_ninety_days'),
        key: 12,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_ninety_one_to_one_hundred_twenty_days'),
        key: 13,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_one_hundred_twenty_one_to_one_hundred_fifty_days'),
        key: 14,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_one_hundred_fifty_one_to_one_hundred_eighty_days'),
        key: 15,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.pending_payment_more_than_one_hundred_eighty_days'),
        key: 16,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]

    for (let item of items) {
      let documentId;
      if (item.invoice) documentId = item.invoice.documentId
      if (item.receipt) documentId = item.receipt.documentId

      worksheet.addRow({
        1: (item.contract && item.contract.customer) ? item.contract.customer.fullName || "" : "",
        2: (item.contract) ? item.contract.contractId || "" : "",
        3: (item.contract) ? item.contract.businessName || "" : "",
        4: documentId || "",
        5: item.contract.areas.map(area => area.name).join(', ') || "",
        6: item.totalDeposit || 0,
        7: item.totaltotalUnpaid || 0,
        8: ((item.totalDeposit || 0) - (item.totaltotalUnpaid || 0)),
        9: item.totalNotDue || 0,
        10: item.total30Day || 0,
        11: item.total60Day || 0,
        12: item.total90Day || 0,
        13: item.total120Day || 0,
        14: item.total150Day || 0,
        15: item.total180Day || 0,
        16: item.totalGreaterThan180Day || 0,
      })
    }
    worksheet.addRow({
      1: i18n.t('sum'),
      6: summary.totalDeposit || 0,
      7: summary.totaltotalUnpaid || 0,
      8: summary.totalDiff || 0,
      9: summary.totalNotDue || 0,
      10: summary.total30Day || 0,
      11: summary.total60Day || 0,
      12: summary.total90Day || 0,
      13: summary.total120Day || 0,
      14: summary.total150Day || 0,
      15: summary.total180Day || 0,
      16: summary.totalGreaterThan180Day || 0
    })

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(items.length + 2).font = { bold: true };
    worksheet.mergeCells(`A${items.length + 2}:E${items.length + 2}`)
    worksheet.getCell(`A${items.length + 2}`).alignment = {
      vertical: 'center',
      horizontal: 'center'
    }
    
    for (let i = 2; i <= items.length + 2; i++) {
      const cellH = worksheet.getCell(`H${i}`);
      const value = cellH.value;

      if (value >= 0) {
        cellH.font = { ...cellH.font, color: { argb: '0029c66f' } }; // สีเขียว
      } else {
        cellH.font = { ...cellH.font, color: { argb: '00eb5455' } }; // สีแดง
      }
    }

    return this.saveFile(workbook, `market-invoice-report-${moment(new Date()).format("DDMMYYYY")}`);
  }

  static async exportMarketBookingReportByMarket(items, bookingType,startDate,endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('booking.booking_number'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('booking.date_booking'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('booking.booking_channel'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.business_name'),
        key: 4,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('booking.booker_name'),
        key: 5,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.stall_list'),
        key: 6,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 7,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.paid'),
        key: 8,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      }, {
        header: i18n.t('payment.pending'),
        key: 9,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      }, {
        header: i18n.t('payment.total_price'),
        key: 10,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]
    for (let item of items) {
      worksheet.addRow({
        1: item.documentId || "",
        2: item.createdAt ? new Date(moment(item.createdAt).format('YYYY-MM-DD')) : "",
        3: item.bookingChannel ? item.bookingChannel.name : '' || "",
        4: item.businessName || '',
        5: item.customer.fullName || '',
        6: item.areaNames || '',
        7: item.statusText || '',
        8: item.sumTotalPaidValue || 0,
        9: item.sumTotalUnpaidValue || 0,
        10: item.sumTotalValue || 0,

      })
    }
    if(startDate && endDate){
      return this.saveFile(workbook, `market-${bookingType || ''}-booking-report-${moment(startDate).format("DD-MM-YYYY")}-to-${moment(endDate).format("DD-MM-YYYY")}`);
    }else{
      return this.saveFile(workbook, `market-${bookingType || ''}-booking-report-${moment(new Date()).format("DDMMYYYY")}`);
    }
  }

  static async exportMarketAppealReportByMarket(items, marketName, startDate, endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('rank'),
        key: 1,
        width: 10,
        style: {
          alignment: {
            vertical: "center",
            horizontal: "center",
          }
        }
      },
      {
        header: i18n.t('appeal.appeal_type'),
        key: 2,
        width: 30,
        style: {
          alignment: {
            vertical: "center",
            horizontal: "center",
          }
        }
      },
      {
        header: i18n.t('created_by'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center",
            horizontal: "center",
          }
        }
      },
      {
        header: i18n.t('task.send_approve_by'),
        key: 4,
        width: 30,
        style: {
          alignment: {
            vertical: "center",
            horizontal: "center",
          }
        }
      },
      {
        header: i18n.t('approve_by'),
        key: 5,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('finish_by'),
        key: 6,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('cancel_by'),
        key: 7,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('created_at'),
        key: 8,
        width: 30,
        style: {
          alignment: {
            vertical: "center",
            horizontal: "center",
          }
        }
      },
      {
        header: i18n.t('task.send_approve_at'),
        key: 9,
        width: 30,
        style: {
          alignment: {
            vertical: "center",
            horizontal: "center",
          }
        }
      },
      {
        header: i18n.t('approve_at'),
        key: 10,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('finish_at'),
        key: 11,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('cancel_at'),
        key: 12,
        width: 30,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('task.time_create_approve'),
        key: 13,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('task.time_approve_finish'),
        key: 14,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      }, {
        header: i18n.t('task.time_process_finish'),
        key: 15,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      }, {
        header: i18n.t('customer.time_summary_create_to_finish'),
        key: 16,
        width: 30,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      }, {
        header: i18n.t('status'),
        key: 17,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]
    worksheet.spliceRows(1, 0, { '1': marketName || '-' })
    worksheet.spliceRows(2, 0, { '1': `${i18n.t('market.data_in_date')} ${startDate || ''} - ${endDate || ''}` })
    worksheet.spliceRows(3, 0, { '1': `` })
    worksheet.getRow(1).alignment = {
      vertical: 'center',
      horizontal: 'center'
    }
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(2).alignment = {
      vertical: 'center',
      horizontal: 'center'
    }
    worksheet.mergeCells('A1:D1')
    worksheet.mergeCells('A2:D2')

    let colorLabel = {
      success: '002ac770',
      cancelled: '00eb5455',
      approved: '00029ce5',
      pending: '00fbae43',
      waiting: '00a9a9a9',
    }
    let order = 0
    for (let item of items) {
      order++
      worksheet.addRow({
        1: order,
        2: item.subCategoryText || "",
        3: item.createdByText || "",
        4: item.statusPendingByText || "",
        5: item.statusApprovedByText || '',
        6: item.statusSuccessByText || '',
        7: item.statusCancelledByText || '',
        8: item.createdAt ? new Date(moment(item.createdAt).format('YYYY-MM-DD')) : "",
        9: item.statusPendingAt ? new Date(moment(item.statusPendingAt).format('YYYY-MM-DD')) : "",
        10: item.statusApprovedAt ? new Date(moment(item.statusApprovedAt).format('YYYY-MM-DD')) : "",
        11: item.statusSuccessAt ? new Date(moment(item.statusSuccessAt).format('YYYY-MM-DD')) : "",
        12: item.statusCancelledAt ? new Date(moment(item.statusCancelledAt).format('YYYY-MM-DD')) : "",
        13: item.time.pending || 0,
        14: item.time.approve || 0,
        15: item.time.success || 0,
        16: item.time.done || 0,
        17: item.statusText || '',
      })
      worksheet.getCell(order + 4, 17).font = { bold: true, color: { argb: colorLabel[item.status] } };
    }
    worksheet.getRow(4).font = { bold: true };
    if(startDate && endDate){
      return this.saveFile(workbook, `market-appeal-report-${startDate}-to-${endDate}`);
    }else{
      return this.saveFile(workbook, `market-appeal-report-${moment(new Date()).format("DDMMYYYY")}`);
    }
  }

  static async exportOccupancyRate(items, date) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: `${i18n.t('area.summary_rental_rate')} ${moment(date).format("D/MM/YYYY")}`,
        key: 1,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.all_stall'),
        key: 2,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.rented_stall'),
        key: 3,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.empty_stall'),
        key: 4,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.rental_rate_stall'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.total_area'),
        key: 6,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.rented_area'),
        key: 7,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.empty_area'),
        key: 8,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.rental_rate_area'),
        key: 9,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]

    for (let item of items) {
      worksheet.addRow({
        1: item.market.name || "",
        2: item.areaCount || 0,
        3: item.areaOccupied || 0,
        4: (item.areaCount - item.areaOccupied) || 0,
        5: Helper.round(item.areaOccupiedRate) + "%",
        6: item.sizeCount || 0,
        7: item.sizeOccupied || 0,
        8: (item.sizeCount - item.sizeOccupied) || 0,
        9: Helper.round(item.sizeOccupiedRate) + "%",
      })
    }

    return this.saveFile(workbook, `project-occupancy-report-${moment(date).format("DDMMYYYY")}`);
  }
}